import { Theme, createTheme } from "@mui/material";

// Formas del design system de Zyra (zyra-core: borderRadiusVariants y botones) para la sección de Registro de jornada, sin
// cambiar todavía los colores ni la letra de la app. Cuando se adopte el Core, esto lo sustituye su tema.
const SUPERFICIE = 10; // tarjetas, avisos y diálogos
const CONTROL = 20;    // botones, campos y chips
const COMPACTO = 5;    // elementos pequeños: tooltips

export const temaJornada = (base: Theme) => createTheme(base, {
    shape: { borderRadius: SUPERFICIE },
    components: {
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: { root: { borderRadius: CONTROL, textTransform: 'none', fontWeight: 500 } },
        },
        MuiPaper: {
            styleOverrides: { rounded: { borderRadius: SUPERFICIE } },
        },
        MuiAlert: {
            styleOverrides: { root: { borderRadius: SUPERFICIE } },
        },
        MuiOutlinedInput: {
            styleOverrides: { root: { borderRadius: CONTROL } },
        },
        MuiChip: {
            styleOverrides: { root: { borderRadius: CONTROL } },
        },
        MuiTooltip: {
            styleOverrides: { tooltip: { borderRadius: COMPACTO } },
        },
        MuiTab: {
            styleOverrides: { root: { textTransform: 'none', fontWeight: 500, fontSize: '0.95rem' } },
        },
        MuiTableCell: {
            styleOverrides: {
                head: { backgroundColor: base.palette.grey[100], fontWeight: 500, borderBottom: 'none' },
            },
        },
    },
});

// Avisos con un botón: en móvil el botón baja debajo del texto (a la derecha); en escritorio, a su lado como siempre
export const avisoConAccionSx = {
    flexWrap: { xs: 'wrap', sm: 'nowrap' },
    '& .MuiAlert-message': { flex: { xs: '1 1 calc(100% - 40px)', sm: '1 1 auto' } },
    '& .MuiAlert-action': {
        width: { xs: '100%', sm: 'auto' },
        justifyContent: 'flex-end',
        ml: { xs: 0, sm: 'auto' },
        pl: { xs: 0, sm: 2 },
        pt: 0,
    },
} as const;
